/*
 * ew-lightbox.js
 *
 * Lightweight IMAGE lightbox for EW product PDPs. Auto-binds to every
 * [data-ew-pdp-gallery]. Zooms IMAGES ONLY: it opens on the currently-visible
 * main-stage image and cycles the image srcs from [data-ew-pdp-thumb] data-src.
 * Videos (data-media-type="video"), external-video embeds, and the bundle cover
 * (data-thumb-type="bundle-cover") are excluded — they play/stay inline. Thumb
 * navigation (element-toggle of the stacked stage items) is owned by
 * assets/ew-pdp-gallery.js, not here.
 *
 * Features:
 *   - Click the main stage while an IMAGE is showing → open lightbox at it
 *   - Native pinch-zoom on touch (touch-action: pinch-zoom)
 *   - Mouse wheel zoom on desktop; click-drag to pan when zoomed
 *   - Arrow keys (←/→) cycle media; ESC closes; click outside closes
 *   - Body scroll locked while open
 *
 * Vanilla JS, no dependencies. ~180 lines.
 */
(function () {
  'use strict';

  var STYLE_ID = 'ew-lightbox-style';
  var STYLE = [
    '.ew-lightbox{position:fixed;inset:0;background:rgba(0,0,0,0.92);z-index:9999;',
      'display:none;align-items:center;justify-content:center;overflow:hidden;',
      'touch-action:pinch-zoom;}',
    '.ew-lightbox[data-open="true"]{display:flex;}',
    '.ew-lightbox__stage{position:relative;width:100%;height:100%;display:flex;',
      'align-items:center;justify-content:center;overflow:hidden;cursor:zoom-in;}',
    '.ew-lightbox__stage[data-zoom="true"]{cursor:grab;}',
    '.ew-lightbox__stage[data-dragging="true"]{cursor:grabbing;}',
    '.ew-lightbox__img{max-width:95vw;max-height:95vh;width:auto;height:auto;',
      'transform-origin:center center;transition:transform 0.18s ease-out;',
      'user-select:none;-webkit-user-drag:none;pointer-events:none;display:block;}',
    '.ew-lightbox__stage[data-dragging="true"] .ew-lightbox__img{transition:none;}',
    '.ew-lightbox__close,.ew-lightbox__nav{position:absolute;background:rgba(0,0,0,0.55);',
      'border:1px solid rgba(255,255,255,0.2);color:#fff;width:44px;height:44px;',
      'border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;',
      'font-size:24px;line-height:1;padding:0;z-index:2;}',
    '.ew-lightbox__close:hover,.ew-lightbox__nav:hover{background:rgba(0,0,0,0.8);}',
    '.ew-lightbox__close{top:16px;right:16px;}',
    '.ew-lightbox__nav--prev{left:16px;top:50%;transform:translateY(-50%);}',
    '.ew-lightbox__nav--next{right:16px;top:50%;transform:translateY(-50%);}',
    '.ew-lightbox__counter{position:absolute;top:16px;left:50%;transform:translateX(-50%);',
      'color:#fff;background:rgba(0,0,0,0.55);padding:6px 12px;border-radius:14px;',
      'font:11px/1 -apple-system,Segoe UI,Roboto,sans-serif;letter-spacing:0.08em;z-index:2;}',
    'body[data-ew-lightbox-open="true"]{overflow:hidden;}',
    '@media (max-width:600px){',
      '.ew-lightbox__nav{display:none;}',
    '}',
  ].join('');

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = STYLE;
    document.head.appendChild(s);
  }

  function buildLightbox() {
    var el = document.createElement('div');
    el.className = 'ew-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Image viewer');
    el.innerHTML = [
      '<div class="ew-lightbox__stage" data-stage>',
        '<img class="ew-lightbox__img" data-img alt="" draggable="false">',
      '</div>',
      '<button type="button" class="ew-lightbox__close" data-close aria-label="Close">&times;</button>',
      '<button type="button" class="ew-lightbox__nav ew-lightbox__nav--prev" data-prev aria-label="Previous image">&#10094;</button>',
      '<button type="button" class="ew-lightbox__nav ew-lightbox__nav--next" data-next aria-label="Next image">&#10095;</button>',
      '<div class="ew-lightbox__counter" data-counter></div>',
    ].join('');
    document.body.appendChild(el);
    return el;
  }

  var lb = null;
  var state = { items: [], idx: 0, scale: 1, tx: 0, ty: 0, dragging: false, lastX: 0, lastY: 0 };

  function getLB() {
    if (!lb) lb = buildLightbox();
    return lb;
  }

  function setImage(idx) {
    state.idx = idx;
    state.scale = 1; state.tx = 0; state.ty = 0;
    var box = getLB();
    var img = box.querySelector('[data-img]');
    var stage = box.querySelector('[data-stage]');
    var counter = box.querySelector('[data-counter]');
    img.src = state.items[idx];
    applyTransform();
    stage.setAttribute('data-zoom', 'false');
    if (state.items.length > 1) {
      counter.textContent = (idx + 1) + ' / ' + state.items.length;
      counter.style.display = '';
    } else {
      counter.style.display = 'none';
    }
    var nav = state.items.length > 1;
    box.querySelector('[data-prev]').style.display = nav ? '' : 'none';
    box.querySelector('[data-next]').style.display = nav ? '' : 'none';
  }

  function applyTransform() {
    var img = getLB().querySelector('[data-img]');
    img.style.transform = 'translate(' + state.tx + 'px,' + state.ty + 'px) scale(' + state.scale + ')';
  }

  function open(items, idx) {
    if (!items.length) return;
    injectStyle();
    state.items = items;
    var box = getLB();
    setImage(idx || 0);
    box.setAttribute('data-open', 'true');
    document.body.setAttribute('data-ew-lightbox-open', 'true');
  }

  function close() {
    var box = getLB();
    box.setAttribute('data-open', 'false');
    document.body.removeAttribute('data-ew-lightbox-open');
  }

  function next() { setImage((state.idx + 1) % state.items.length); }
  function prev() { setImage((state.idx - 1 + state.items.length) % state.items.length); }

  function attachLightboxEvents() {
    var box = getLB();
    var stage = box.querySelector('[data-stage]');
    var img = box.querySelector('[data-img]');

    box.querySelector('[data-close]').addEventListener('click', close);
    box.querySelector('[data-prev]').addEventListener('click', function (e) { e.stopPropagation(); prev(); });
    box.querySelector('[data-next]').addEventListener('click', function (e) { e.stopPropagation(); next(); });

    /* Click outside image (on backdrop) closes */
    stage.addEventListener('click', function (e) {
      if (e.target === stage) {
        if (state.scale > 1) { state.scale = 1; state.tx = 0; state.ty = 0; applyTransform(); stage.setAttribute('data-zoom', 'false'); return; }
        close();
      }
    });

    /* Wheel zoom */
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var delta = e.deltaY > 0 ? -0.15 : 0.15;
      var newScale = Math.max(1, Math.min(5, state.scale + delta));
      state.scale = newScale;
      if (newScale === 1) { state.tx = 0; state.ty = 0; }
      stage.setAttribute('data-zoom', newScale > 1 ? 'true' : 'false');
      applyTransform();
    }, { passive: false });

    /* Click-drag pan when zoomed */
    stage.addEventListener('mousedown', function (e) {
      if (state.scale <= 1) return;
      state.dragging = true;
      state.lastX = e.clientX; state.lastY = e.clientY;
      stage.setAttribute('data-dragging', 'true');
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!state.dragging) return;
      state.tx += e.clientX - state.lastX;
      state.ty += e.clientY - state.lastY;
      state.lastX = e.clientX; state.lastY = e.clientY;
      applyTransform();
    });
    window.addEventListener('mouseup', function () {
      if (!state.dragging) return;
      state.dragging = false;
      stage.removeAttribute('data-dragging');
    });

    /* Keyboard nav */
    document.addEventListener('keydown', function (e) {
      if (box.getAttribute('data-open') !== 'true') return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft' && state.items.length > 1) prev();
      else if (e.key === 'ArrowRight' && state.items.length > 1) next();
    });
  }

  /* The <img> of the currently-visible main-stage item, or null when the
     visible item is a video / external embed / bundle cover (no zoom for those).
     The stage stacks one [data-ew-pdp-stage] per media, only one without [hidden]. */
  function visibleStageImg(galleryRoot) {
    var main = galleryRoot.querySelector('[data-ew-pdp-main]');
    if (!main) return null;
    var stages = main.querySelectorAll('[data-ew-pdp-stage]');
    for (var i = 0; i < stages.length; i++) {
      if (stages[i].hidden) continue;
      if (stages[i].getAttribute('data-media-type') === 'image') {
        return stages[i].querySelector('img');
      }
      return null; /* visible item is a video / cover — not zoomable */
    }
    /* Legacy fallback: main element is itself an <img>. */
    return main.tagName === 'IMG' ? main : null;
  }

  /* IMAGE srcs only, in gallery order. Videos (data-media-type="video") and the
     bundle cover (data-thumb-type="bundle-cover") are excluded — they never
     enter the zoom sequence. Falls back to the visible image on single-image
     PDPs that render no thumb strip. */
  function collectMedia(galleryRoot) {
    var items = [];
    galleryRoot.querySelectorAll('[data-ew-pdp-thumb]').forEach(function (btn) {
      if (btn.getAttribute('data-thumb-type') === 'bundle-cover') return;
      if (btn.getAttribute('data-media-type') === 'video') return;
      var src = btn.getAttribute('data-src');
      if (src && items.indexOf(src) === -1) items.push(src);
    });
    if (!items.length) {
      var vImg = visibleStageImg(galleryRoot);
      var s = vImg && vImg.getAttribute('src');
      if (s) items.push(s);
    }
    return items;
  }

  function bindGallery(galleryRoot) {
    var main = galleryRoot.querySelector('[data-ew-pdp-main]');
    if (!main) return;
    /* Open the lightbox only when an IMAGE is showing; a visible video plays
       inline and its poster is never fed to the zoom viewer. */
    main.addEventListener('click', function () {
      var vImg = visibleStageImg(galleryRoot);
      if (!vImg) return;
      var freshItems = collectMedia(galleryRoot);
      if (!freshItems.length) return;
      var idx = freshItems.indexOf(vImg.getAttribute('src'));
      open(freshItems, idx >= 0 ? idx : 0);
    });
  }

  function boot() {
    var galleries = document.querySelectorAll('[data-ew-pdp-gallery]');
    if (!galleries.length) return;
    injectStyle();
    getLB();
    attachLightboxEvents();
    galleries.forEach(bindGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Expose for debug */
  window.EWLightbox = { open: open, close: close };
})();
